import { useCallback, useContext, useEffect } from "react";
import AllRoutes from "./AllRoutes";
import "./App.css";
import { MyContext } from "./hooks/MyContextProvider";
import AOS from "aos";
import ScrollToTop from "./hooks/ScrollToTop";
function App() {
  const { callCartAPI, token, adminToken } = useContext(MyContext);

  useEffect(() => {
    AOS.init({
      offset: 200,
      duration: 600,
      easing: "ease-in-sine",
      delay: 100,
    });
  }, []);

  useEffect(() => {
    if (token) {
      callCartAPI();
    }
  }, [token, callCartAPI]);

  useEffect(() => {
    const rootElement = document.getElementById("root");
    if (rootElement) {
      if (adminToken) {
        rootElement.classList.add("root-admin");
        rootElement.classList.remove("root");
      } else {
        rootElement.classList.add("root");
        rootElement.classList.remove("root-admin");
      }
    }
  }, [adminToken]);

  return (
    <>
      <ScrollToTop />
      <AllRoutes />
    </>
  );
}

export default App;
